export const AUTHORIZED_SIGNER_CONTRACT = 'Authorized Signer Contact';

export const CONTACT_LIST = [
  'Primary Account Contact',
  'Membership Contact',
  'Billing Contact',
  'IT Contact',
  AUTHORIZED_SIGNER_CONTRACT,
];
